import { render } from "./Categorias.vue?vue&type=template&id=e583056e&scoped=true"
import script from "./Categorias.vue?vue&type=script&lang=js"
export * from "./Categorias.vue?vue&type=script&lang=js"

import "./Categorias.vue?vue&type=style&index=0&id=e583056e&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e583056e"]])

export default __exports__